const initialState = {
    nominees: [],
    personal_details: {},
    health_information: {},
};

const lifePlanReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_NOMINEES':
            return {
                ...state,
                nominees: action.payload,
            };
        case 'SET_PERSONAL_DETAILS':
            return {
                ...state,
                personal_details: action.payload,
            };
        case 'SET_HEALTH_INFORMATION':
            return {
                ...state,
                health_information: action.payload,
            };
        default:
            return state;
    }
};

export default lifePlanReducer;